module.exports = __webpack_public_path__ + "img/NF.190923a8.png";